import React from "react";

import { Caption } from "../../../styles";
import { BarSegment, BarTrack, Legend, LegendItem, Swatch } from "../../styles";
import { QueueBarProps } from "./types";

export const QueueBar: React.FC<QueueBarProps> = ({ segments, emptyLabel }) => {
  const filled = segments.filter(({ count }) => count > 0);

  return (
    <>
      {filled.length === 0 ? (
        <Caption>{emptyLabel}</Caption>
      ) : (
        <BarTrack aria-hidden="true">
          {filled.map(({ label, count, color }) => (
            <BarSegment key={label} $count={count} $color={color} />
          ))}
        </BarTrack>
      )}
      <Legend>
        {segments.map(({ label, count, color }) => (
          <LegendItem key={label}>
            <Swatch $color={color} aria-hidden="true" />
            <span>
              {label}: {count}
            </span>
          </LegendItem>
        ))}
      </Legend>
    </>
  );
};
